var T = Object.defineProperty;
var u = Object.getOwnPropertySymbols;
var D = Object.prototype.hasOwnProperty, k = Object.prototype.propertyIsEnumerable;
var v = (t, a, e) => a in t ? T(t, a, { enumerable: !0, configurable: !0, writable: !0, value: e }) : t[a] = e, l = (t, a) => {
  for (var e in a || (a = {}))
    D.call(a, e) && v(t, e, a[e]);
  if (u)
    for (var e of u(a))
      k.call(a, e) && v(t, e, a[e]);
  return t;
};
import { Y as I, a6 as O } from "../index-CRFXyvqr.js";
import { queryURLParams as y } from "../url/index.js";
function f(t) {
  const a = [];
  for (let e in t) Object.prototype.hasOwnProperty.call(t, e) && a.push({ eventKey: e, eventValue: t[e] === 0 ? 0 : t[e] || "" });
  return a;
}
function F({ eventId: t, code: a = "", eventType: e = "", deviceId: p = "", pkgName: n = "", appType: o = "", channel: d = "", appVersion: s, curPageId: i = "", prePageId: c } = {}, g = {}) {
  const { gaid: m, aid: r, appVersion: h, channel: P, code: V, pkg: w, appType: N } = I();
  return { adId: m || "", deviceId: p || r || "", pkgName: n || w || "", appType: o || N || "", events: [{ userCode: a || V || y("code") || localStorage.getItem("code") || "", eventVer: "1", created: Date.now(), appVer: s || h || "", srcChannel: d || P || "", eventId: t, eventType: e, curPageId: i, prePageId: c, params: JSON.stringify(f(g)) }] };
}
function J(t, { platform: a, shareFrom: e = "", taurusAppName: p = "", code: n = "", appVersion: o } = {}, d = {}) {
  const { gaid: s, aid: i, appVersion: c, channel: g, code: m } = I(), r = { aid: i || "", gaid: s || "", appVersion: (o = c || o) || "", channel: g || "", code: (n = n || m || y("code") || "") || "", platform: a || "", shareFrom: e, taurusAppName: p, type: "event", listJson: [{ code: n || "", eventId: t, ts: Math.floor(Date.now() / 1e3), version: o, eventParamList: f(d) }] };
  return window.navigator ? l({ os: O().os }, r) : r;
}
export {
  F as getNewReportPointData,
  J as getReportPointData
};
